<template>
  <div>
    <v-row class="pa-6">
      <v-col
        cols="6"
        sm="4"
        md="3"
        lg="2"
        v-for="(folder, i) in folders"
        :key="i"
        class="py-4"
      >
        <div class="container" @click="enterFiles(folder)">
          <div class="folder_tab"></div>
          <div class="folder d-flex align-center justify-center">
            <div>
                <!-- <v-dialog max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      dark
                      small
                      color="error"
                      fab
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-dialog> -->
              <div class="font-weight-bold"
                :style="
                  $vuetify.breakpoint.mdAndUp
                    ? 'font-size: 1rem'
                    : 'font-size: 1rem'
                ">{{ folder.name }}</div>
              <div class="text-caption">
                {{ folder.Arquivos }} {{ $t('courses.courses_arquivo') }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
const axios = require("axios");
const url = process.env.VUE_APP_API_URL;
const token = "Baerer " + localStorage.getItem("accessToken");
const authorization = { headers: { authorization: token } };

export default {
  data() {
    return {
      folders: [],
      formFolder: {},
      formCurso: {},
      editfolders: {},
      editcurso: {},
      couser: [],
      folderAssemblies: [],
      rules: {
        email: (v) =>
          !!(v || "").match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || this.$t('regras.regra_email'),
        length: (len) => (v) =>
          (v || "").length >= len ||
          `${this.$t('regras.regra_senhaMini.senha1')} ${len} ${this.$t('regras.regra_senhaMini.senha2')}`,
        maxLength: (len) => (v) =>
          (v || "").length <= len ||
          `${this.$t('regras.regra_senhaMax.senha1')} ${len} ${this.$t('regras.regra_senhaMax.senha2')}`,
        required: (v) => !!v || this.$t('regras.regra_obrigatorio'),
        option: (v) => !!v || this.$t('regras.regra_opcao'),
        image: (v) => !!v || this.$t('regras.regra_image'),
        file: (v) => !!v || this.$t('regras.regra_file'),
        question: (v) => !!v || this.$t('regras.regra_question'),
        date: (v) => !!v || this.$t('regras.regra_data'),
        user: (v) =>
          !!(v || "").match(/^[a-zA-Z0-9.]*$/) ||
          `${this.$t('regras.regra_user')}`,
        none: true,
      },
    };
  },

  created() {
    this.getfolderAssemblies();
    this.getFolders();
    this.getCourses();
  },
  
  methods: {
    enterFiles(item) {
      this.$emit("enterFiles", { path: "Schools Files", idSchools: item.idSchools });
    },

    async getFolders() {
      let res = await axios.get(`${url}/schoolsRegister`, authorization);
      this.folders = res.data;
    },

    getCourses() {
      axios
        .get(`${url}/courses`, {
          headers: {
            authorization: token,
          },
        })
        .then((response) => {
          this.couser = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async getfolderAssemblies() {
      let res = await axios.get(`${url}/folderAssemblies`, authorization);
      this.folderAssemblies = res.data;
    },
  },
};
</script>

<style lang="css" scoped>
.container {
  padding: 5px;
  text-align: center;
}
.folder_tab,
.folder {
  margin: 0 auto;
  background-color: #ffe189;
  cursor: pointer;
}
.folder_tab {
  width: 40%;
  height: 15px;
  margin-right: 60%;
  border-radius: 10px 20px 0 0;
}
.folder {
  height: 150px;
  border-radius: 0 10px 10px 10px;
  box-shadow: 3px 6px 5px 0px #cccccc;
}
</style>
